import Navigation from "../../components/Navigation";
import { Link } from "react-router-dom"; // Add Link import
import { FileText, Gavel, TrendingUp, ArrowRight } from "lucide-react"; // Add Lucide imports
import { Helmet } from "react-helmet-async";
import "./style.css"; // Assuming this is Services.css now

const services = [
	{ 
        title: "Taxation", 
        desc: [
            "Tax Debt Compromise Applications",
            "Alternative Dispute Resolution (ADR)",
            "Income Tax Returns (Individual & Company)",
            "Provisional Tax Calculations & Submissions",
            "VAT Registration & Returns Submissions",
            "PAYE Submissions",
            "Trust Registration",
        ],
        icon: FileText,
        // slug: "/services/tax-advisory"
    },
	{ 
        title: "Legal Advisory", 
        desc: [
            "Civil litigation",
            "Drafting, Reviewing & Vetting of Contracts and Agreements",
            "Legal Notices & Advisory",
        ],
        icon: Gavel,
        // slug: "/services/legal-consulting"
    },
	// { 
    //     title: "VAT & SARS eFiling", 
    //     desc: [
    //         "Placeholder"
    //     ],
    //     icon: Briefcase,
    //     // slug: "/services/business-solutions"
    // },
	{ 
        title: "Secretarial Services", 
        desc: [
            "Bookkeeping",
            "Company registration",
            "CIPC Amendments & Annual Returns",
            "Basic Payroll Assistance"
        ],
        icon: TrendingUp,
        // slug: "/services/financial-planning"
    },
    {
        title: "Deceased Estates Administration",
        desc: [
            "Estate Late Tax Registrations",
            "Final and Outstanding Tax Returns",
            "Liaison with SARS",
            "Tax Compliance for Deceased Estates"
        ],
        icon: ArrowRight,
        // slug: "/services/financial-planning"
    }
];

const Services = () => {
	return (
		<div className="services-page-wrapper">
			<Navigation />
			<Helmet>
				<title>Jean Tax & Legal Practitioners | Services</title>
				<meta name="description" content="Explore our professional services including taxation, legal advisory, secretarial services, and deceased estate administration." />
				<meta name="keywords" content="tax services, legal services, secretarial services, deceased estates, SARS, CIPC" />
				<link rel="canonical" href="https://jeantaxandlegal.co.za/services" />
				<meta property="og:title" content="Jean Tax & Legal Practitioners | Services" />
				<meta property="og:description" content="Comprehensive tax and legal support for your business or personal needs." />
				<meta property="og:type" content="website" />
				<meta property="og:url" content="https://jeantaxandlegal.co.za/services" />
			</Helmet>
			<main className="services-main"> 
				
				{/* Hero Section */}
				<section className="services-hero">
                    <div className="container">
                        <div className="hero-content">
                            <h1>Our Comprehensive Services</h1>
                            <div className="hero-underline"></div> 
                            <p>We deliver premium, reliable tax, legal, and business solutions tailored to your unique needs.</p>
                        </div>
                    </div>
				</section>

				{/* Services List Grid */}
				<section className="services-list">
                    <div className="container">
                        {/* Renamed from services-cards to services-cards-grid */}
                        <div className="services-cards-grid"> 
                            {services.map((s, i) => (
                                <Link to={s.slug} className="service-card-link" key={i}>
                                    <div className="card service-card"> {/* Added service-card class */}
                                        <div className="card-icon">
                                            {s.icon && <s.icon size={36} />} 
                                        </div>
                                        <h3 className="card-title">{s.title}</h3> {/* Added card-title class */}
                                        <ul className="card-description">
                                            {s.desc.map((point, index) => (
                                                <li key={index}>{point}</li>
                                            ))}
                                        </ul> {/* Added card-description class */}
                                        {/* <div className="read-more">
                                            Learn More <ArrowRight size={16} />
                                        </div> */}
                                    </div>
                                </Link>
                            ))}
                        </div>
                    </div>
				</section>
			</main>
			<br />
			{/* <Footer /> */}
		</div>
	);
};

export default Services;